var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "competitor-list" }, [_c('table-list', { ref: "table", attrs: { "list": _vm.innerList, "columnConfig": _vm.tableColumnConfig, "tableConfig": _vm.tableConfig } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };